import React, { useState } from 'react'
import styles from './CTASection.module.css'
import buildingImg from '../../assets/building.png'
import reraQR from '../../assets/qr-code.jpg'
import CTAPopup from '../../components/CTAPopup/CTAPopup'
import { notifyCTAEnquiry } from '../../lib/whatsapp/sendWhatsApp'

const CTASection = () => {
    const [form, setForm] = useState({ name: '', phone: '', email: '', consent: true })
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [popupOpen, setPopupOpen] = useState(false)

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setError('')
        try {
            await notifyCTAEnquiry({
                name: form.name,
                phone: form.phone,
                email: form.email,
            })
            setSubmitted(true)
        } catch (err) {
            console.error('WhatsApp notification failed:', err)
            setError('Something went wrong. Please try again.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <section className={styles.section}>
                <div className={styles.bgTexture}></div>

                {/* Left: Building + RERA */}
                <div className={styles.leftPanel}>
                    <img
                        src={buildingImg}
                        alt="The Everett Building"
                        className={styles.buildingImg}
                    />
                    <div className={styles.leftOverlay}></div>

                    {/* RERA Card */}

                </div>

                {/* Right: Form panel */}
                <div className={styles.rightPanel}>
                    <div className={styles.formBox}>

                        <div className={styles.formHeader}>
                            <span className={styles.eyebrow}>
                                <span className={styles.eyebrowLine}></span>
                                THE EVERETT · LULLANAGAR
                                <span className={styles.eyebrowLine}></span>
                            </span>
                            <h2 className={styles.heading}>
                                Begin Your Journey<br />
                                <em>to Refined Living</em>
                            </h2>
                            <p className={styles.subheading}>
                                Register your interest and our team will reach out with
                                exclusive pricing, floor plans and an invitation to visit.
                            </p>
                        </div>

                        <div className={styles.divider}></div>

                        {submitted ? (
                            <div className={styles.successBox}>
                                <div className={styles.successIcon}>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M20 6L9 17l-5-5" />
                                    </svg>
                                </div>
                                <h3 className={styles.successTitle}>Thank You</h3>
                                <p className={styles.successText}>
                                    We've received your enquiry. Our team will be in touch with you shortly.
                                </p>
                            </div>
                        ) : (
                            <form className={styles.form} onSubmit={handleSubmit}>
                                <div className={styles.formRow}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}>Full Name *</label>
                                        <input
                                            className={styles.input}
                                            type="text"
                                            name="name"
                                            placeholder="Your name"
                                            value={form.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}>Phone Number *</label>
                                        <input
                                            className={styles.input}
                                            type="tel"
                                            name="phone"
                                            placeholder="+91 00000 00000"
                                            value={form.phone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.label}>Email Address</label>
                                    <input
                                        className={styles.input}
                                        type="email"
                                        name="email"
                                        placeholder="Optional"
                                        value={form.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <label className={styles.consent}>
                                    <input
                                        type="checkbox"
                                        name="consent"
                                        checked={form.consent}
                                        onChange={handleChange}
                                        className={styles.checkbox}
                                    />
                                    <span>
                                        I consent to the processing of provided data according to{' '}
                                        <a href="#privacy">Privacy Policy</a> &amp; <a href="#terms">Terms &amp; Conditions</a>
                                    </span>
                                </label>

                                {error && <p className={styles.errorText}>{error}</p>}

                                <button className={styles.submitBtn} type="submit" disabled={loading}>
                                    {loading ? 'Sending...' : 'Enquire Now'}
                                    {!loading && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14M12 5l7 7-7 7" />
                                        </svg>
                                    )}
                                </button>

                                <button
                                    className={styles.brochureBtn}
                                    type="button"
                                    onClick={() => setPopupOpen(true)}
                                >
                                    Download Brochure
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                    </svg>
                                </button>
                            </form>
                        )}

                        <div className={styles.priceNote}>
                            <span className={styles.priceLabel}>Starting from</span>
                            <span className={styles.priceValue}>₹3.75 Cr*</span>
                            <span className={styles.priceTag}>onwards</span>
                        </div>
                        <div className={styles.reraCard}>
                            <div className={styles.reraLeft}>
                                <span className={styles.reraLabel}>MAHARERA REGISTERED</span>
                                <span className={styles.reraNumber}>P52100077316</span>
                                <a
                                    href="https://maharera.mahaonline.gov.in"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.reraLink}
                                >
                                    maharera.mahaonline.gov.in
                                </a>
                            </div>
                            <div className={styles.reraDivider}></div>
                            <div className={styles.reraRight}>
                                <img
                                    src={reraQR}
                                    alt="MahaRERA QR Code"
                                    className={styles.reraQR}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CTAPopup
                isOpen={popupOpen}
                onClose={() => setPopupOpen(false)}
                title="Download Brochure"
                subtitle="Share your details and we'll send you The Everett's complete brochure with floor plans, pricing and amenity details."
            />
        </>
    )
}

export default CTASection